import React, {useEffect, useState} from 'react';
import queryString from 'query-string';
import {update_discount, add_discount, discount} from '../../service/discount'
import { providers } from '../../service/providers'
import '../margin_add/style.css';

const DiscountAdd = ({user_token, set_menu, authorize}) => {
    const [discount_d, setDiscountD] = useState(null);
    const [description, setDescription] = useState("");
    const [discount_type, setDiscountType] = useState(0);
    const [prod_type, setProdType] = useState(0);

    const [prov_id, setProvID] = useState(null);

    const [order, setOrder] = useState(0);
    const [amount, setAmount] = useState(0);
    const [per_pax, setPerPax] = useState(0);
    const [btn_lbl, setBtnLbl] = useState('Add');
    const [ready, setReady] = useState(false)

    const [available_providrs, setAvailableProviders] = useState([])
    
   
    const select_prod_type = (value) => {

        update_avail_provs(value)
        setProdType(value)
    }

    useEffect(() => {

        authorize(1);
  
        let x = queryString.parse(document.location.search);
    
        const lnks = [{'url': '/', 'name': 'Home'}, {'url': '/discounts', 'name': 'Discounts'}]
		set_menu(lnks)

        if(x.did == null){
            setReady(true);
            update_avail_provs(prod_type)
            return
        }
        let f = "id description discount_type product_type per_pax order amount provider";

        discount(Number(x.did),f, user_token).then((r) =>{

            if(r == null){
				return
			}
			if(r.errors != null){
				if(r.errors.length > 0){
					alert(r.errors[0].message)
					return
				}
				alert("Unexpected Error Contact HWT support...")
				return
			}
			if(r.discount.error != null){
				alert(r.discount.error.message)
				return
			}	

            if(r.discount.result == null){
				return
			}
            update_avail_provs(r.discount.result.product_type)
            setDiscountD(r.discount.result);
            setDescription(r.discount.result.description);
            setDiscountType(r.discount.result.discount_type);
            setProdType(r.discount.result.product_type);
            setProvID(r.discount.result.provider);
            setOrder(r.discount.result.order);
            setAmount(r.discount.result.amount);
            setPerPax(r.discount.result.per_pax)
            setBtnLbl('Update');
            setReady(true);
        });
    }, [])


    const update_avail_provs = (selected_prod_type) => {
        let provs = [];
        for(let x of providers){
            if(Number(selected_prod_type) == x.product_type){
                provs.push(x);
            }
        }
        setAvailableProviders(provs)
    }

    const perPax = (chk, value) => {
        if(chk && value == 0){
            setPerPax(0);
        }
        else{
            setPerPax(1);
        }
    }

    const addupdate_discount = async () => {

        let desc = document.getElementById("txt_desc").value;
        let type = document.getElementById("ddl_type").value;
        let prod_type = document.getElementById("ddl_prodtype").value;

        let prov_type = document.getElementById("ddl_prov").value;

        let ord = document.getElementById("txt_order").value;
        let amount = document.getElementById("txt_amount").value;
        let x = document.querySelector('input[name="optPerPax"]:checked').value;

        //make graph all and add this sucker
        if(discount_d == null){
            let new_discount = await add_discount(desc, type, amount, per_pax, prod_type, prov_type, ord , "id", user_token)
            if(new_discount == null){
                alert("Failed to add discount. Contact HWT support");
                return
            }
        }
        else{
            let new_discount = await update_discount(discount_d.id, desc, type, amount, per_pax, prod_type, prov_type, ord, "id", user_token)
            if(new_discount == null){
                alert("Failed to add discount. Contact HWT support");
                return
            }
        }
  
        
        window.location.replace("/discounts");

    }

    if(!ready){
        return(<div className='input_form'>Loading form...</div>)
    }


    let type_ops = [{"value": 0, "text": "Monetary (£)"}, {"value": 1, "text": "Percentage (%)"}]
    let type_ops_x = [];
    for(let x of type_ops){
        if(discount_type == x.value){
            type_ops_x.push(<option selected={true} value={x.value}>{x.text}</option>);
        }
        else{
            type_ops_x.push(<option value={x.value}>{x.text}</option>);
        }
    }  
    
    let prod_type_ops = [{"value": 0, "text": "Accommodation"}, {"value": 1, "text": "Flights"}, {"value": 2, "text": "Flight Extras"}, {"value": 3, "text": "Transfers"}
    , {"value": 4, "text": "Vehicle Hire"}, {"value": 5, "text": "Package"}]

    let prod_type_ops_x = [];

    for(let x of prod_type_ops){
        if(prod_type == x.value){
            prod_type_ops_x.push(<option selected={true} value={x.value}>{x.text}</option>);
        }
        else{
            prod_type_ops_x.push(<option value={x.value}>{x.text}</option>);
        }
    }

    let descriptionx = <div className='input_section'>
        <div className='input_label_section'>
            <label>Description</label>
        </div>
        <div className='input_field_section large'>
            <input id='txt_desc' onChange={(d) => setDescription(d.value)} value={description}></input>
        </div>
    </div>

    let mtype = <div className='input_section'>
          <div className='input_label_section'>
            <label>Discount Type</label>
        </div>
        <div className='input_field_section'>
            <select id='ddl_type' onChange={(d) => setDiscountType(d.value)}>
                {type_ops_x}
            </select>
        </div>
    </div>

    let ptype = <div className='input_section'>
    <div className='input_label_section'>
    <label>Product Type</label>
    </div>
    <div className='input_field_section'>
    <select id='ddl_prodtype' onChange={(d) => select_prod_type(d.target.value)}>

        {prod_type_ops_x}
    </select>
    </div>
    </div>
    
    


    let provs = [];   
    provs.push(<option value={""}>N/A</option>);
        for(let x of available_providrs){
            if(prov_id == x.value){
                provs.push(<option selected={true} value={x.value}>{x.text}</option>);
            }
            else{
                provs.push(<option value={x.value}>{x.text}</option>);
            }
        }

        let prov = <div className='input_section'>
        <div className='input_label_section'>
        <label>Provider</label>
        </div>
        <div className='input_field_section'>
        <select id='ddl_prov'>
            {provs}
        </select>
        </div>
        </div>

    // let orderx = <div className='input_section'>
    // <div className='input_label_section'>
    //     <label>Order</label>
    // </div>
    // <div className='input_field_section medium'>
    //     <input id='txt_ord' onChange={(d) => setOrder(d.value)} type='number' value={order}></input>
    // </div>
    // </div>

    let ord = <div className='input_section'>
    <div className='input_label_section'>
        <label>Order</label>
        <p style={{fontSize:'13px'}}>The smaller the number, the higher the rule’s priority.</p>
    </div>
    <div className='input_field_section medium'>
        <input id='txt_order' onChange={(d) => setOrder(d.value)} type='number' value={order}></input>
    </div>
    </div>

    let amt = <div className='input_section'>
    <div className='input_label_section'>
        <label>Amount</label>
    </div>
    <div className='input_field_section medium'>
        <input id='txt_amount' onChange={(d) => setAmount(d.value)} type='number' value={amount}></input>
    </div>
    </div>

    let noCheck = true;
    let yesCheck = false;
    if(per_pax == 1){
        noCheck = false;
        yesCheck = true;
    }

    let amt_per_pax = <div className='input_section'>
    <div className='input_label_section'>
        <label>Per person (e.g if Yes amount = Amount * number of pax)</label>
    </div>
    <div className='input_field_section'>
        <input type="radio" id="optPerPaxNo" onChange={(d) => perPax(d.target.checked, d.target.value)} checked={noCheck} name="optPerPax" value="0"></input>
        <label for="optPerPaxNo">No</label>
        <input type="radio" id="optPerPaxYes" onChange={(d) => perPax(d.target.checked, d.target.value)} checked={yesCheck} name="optPerPax" value="1"></input>
        <label for="optPerPaxYes">Yes</label>
    </div>
    </div>

    let btn = <div className='btn_section'>
        <button onClick={() => {addupdate_discount()}}>{btn_lbl}</button>
    </div>

    return(<div className='input_form'>
        {descriptionx}
        {mtype}
        {ptype}
        {prov}
        {ord}
        {amt}
        {amt_per_pax}
        {btn}
    </div>);


};

export default DiscountAdd
